import { motion } from "framer-motion";
import { Search, CreditCard, BarChart3, Truck } from "lucide-react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

const meta = {
  source: { Icon: Search, red: false },
  pay: { Icon: CreditCard, red: true },
  finance: { Icon: BarChart3, red: false },
  move: { Icon: Truck, red: true },
};

export const Services = () => {
  const { t } = useLang();
  return (
    <section data-testid="services-section" id="services" className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <h2 className="font-display text-4xl md:text-[3.4rem] font-bold tracking-tight text-sinovar-navy leading-[1.05]">
            {t.services.titleA}
            <br />
            <span className="text-sinovar-red">{t.services.titleB}</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.services.items.map((s, i) => {
            const { Icon, red } = meta[s.key];
            return (
              <motion.div
                key={s.key}
                id={s.key}
                data-testid={`service-card-${s.key}`}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                whileHover={{ y: -4 }}
                className="group scroll-mt-24 rounded-2xl border border-black/[0.08] bg-white p-8 hover:border-sinovar-blue/25 hover:shadow-xl hover:shadow-sinovar-navy/5 transition-[box-shadow,border-color] duration-300"
              >
                <Icon className={`h-11 w-11 ${red ? "text-sinovar-red" : "text-sinovar-blue"}`} strokeWidth={1.5} />
                <div className="mt-8 text-xs font-bold uppercase tracking-[0.12em] text-sinovar-navy/70">{s.name}</div>
                <div className="mt-1 font-display text-2xl font-bold tracking-tight text-sinovar-navy">{s.tagline}</div>
                <div className="mt-4 h-0.5 w-8 rounded-full bg-sinovar-red" />
                <p className="mt-4 text-[15px] text-sinovar-navy/55 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
